import React, { useCallback, useEffect, useMemo, useState } from 'react';
import Select from '../../../components/ui/Select';
import {
  formatChannelGroupLabel,
} from '../utils/channelOptions';
import { fetchChannelOptionGroups } from '../utils/fetchChannelOptionGroups';

function ChannelAnchorSelect({
  id = 'channel-anchor',
  value,
  onChange,
  disabled = false,
  onGroupsLoaded,
}) {
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');
  const [groups, setGroups] = useState([]);
  const [lineByCatalogId, setLineByCatalogId] = useState({});

  const loadOptions = useCallback(async () => {
    setLoading(true);
    setError('');

    try {
      const { groups, lineByCatalogId } = await fetchChannelOptionGroups();
      setGroups(groups);
      setLineByCatalogId(lineByCatalogId);
      onGroupsLoaded?.(groups, lineByCatalogId);
    } catch {
      setError('Não foi possível carregar os canais WhatsApp.');
      setGroups([]);
      setLineByCatalogId({});
      onGroupsLoaded?.([], {});
    } finally {
      setLoading(false);
    }
  }, [onGroupsLoaded]);

  useEffect(() => {
    loadOptions();
  }, [loadOptions]);

  const options = useMemo(() => {
    const base = [{ value: '', label: loading ? 'Carregando canais...' : 'Selecione um canal' }];
    return [
      ...base,
      ...groups.map((group) => ({
        value: group.anchorChannelId,
        label: formatChannelGroupLabel(group, lineByCatalogId),
      })),
    ];
  }, [groups, lineByCatalogId, loading]);

  return (
    <div>
      <Select
        id={id}
        label="Canal âncora (WhatsApp)"
        value={value}
        onChange={onChange}
        options={options}
        disabled={disabled || loading}
        required={!disabled}
      />
      <p className="mt-1.5 text-xs text-content-muted">
        Escolha o número WhatsApp compartilhado entre os agentes.
      </p>
      {!loading && groups.length === 0 && !error && (
        <p className="mt-1.5 text-xs text-amber-700">
          Nenhum WhatsApp compartilhado entre dois ou mais agentes foi encontrado.
        </p>
      )}
      {error && <p className="mt-1.5 text-xs text-red-600">{error}</p>}
    </div>
  );
}

export default ChannelAnchorSelect;
